module.exports = __webpack_public_path__ + "assets/bulb-green-e392501b53be7d2bd9289ac5d927d544.png";